/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecutionPlanResourceDto
 */
export interface ExecutionPlanResourceDto {
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanResourceDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanResourceDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanResourceDto
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanResourceDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanResourceDto
     */
    role?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanResourceDto
     */
    notionalCapacityHoursPerWeek?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExecutionPlanResourceDto
     */
    active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanResourceDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanResourceDto
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the ExecutionPlanResourceDto interface.
 */
export function instanceOfExecutionPlanResourceDto(value: object): value is ExecutionPlanResourceDto {
    return true;
}

export function ExecutionPlanResourceDtoFromJSON(json: any): ExecutionPlanResourceDto {
    return ExecutionPlanResourceDtoFromJSONTyped(json, false);
}

export function ExecutionPlanResourceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionPlanResourceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'name': json['name'] == null ? undefined : json['name'],
        'role': json['role'] == null ? undefined : json['role'],
        'notionalCapacityHoursPerWeek': json['notionalCapacityHoursPerWeek'] == null ? undefined : json['notionalCapacityHoursPerWeek'],
        'active': json['active'] == null ? undefined : json['active'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function ExecutionPlanResourceDtoToJSON(json: any): ExecutionPlanResourceDto {
    return ExecutionPlanResourceDtoToJSONTyped(json, false);
}

export function ExecutionPlanResourceDtoToJSONTyped(value?: ExecutionPlanResourceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'userId': value['userId'],
        'name': value['name'],
        'role': value['role'],
        'notionalCapacityHoursPerWeek': value['notionalCapacityHoursPerWeek'],
        'active': value['active'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

